import {AfterViewInit, ApplicationRef, Component, OnInit, ViewChild} from '@angular/core';

import {PushMessageDatabaseService} from './push-message-database.service';
import {
  PushMessageGridConfiguration, PushMessageRequestModel
} from './push-message-database.model';
import {DxGridHelper} from '../../shared/helpers/dx-grid-helper';

@Component({
  selector: 'app-push-message-database',
  templateUrl: './push-message-database.component.html',
  providers: [PushMessageDatabaseService],
  styleUrls: ['./push-message-database.component.less']
})
export class PushMessageDatabaseComponent implements OnInit, AfterViewInit {

  @ViewChild('Grid') private Grid;

  selectedPushMessageId: number;
  showPushMessage = false;
  showEditGuests = false;
  cloneExistingPushMessage = false;

  PushMessagesGridConfiguration = new PushMessageGridConfiguration();
  PushMessagesGridRequest = new PushMessageRequestModel();

  

  constructor(private pushMessageDatabaseService: PushMessageDatabaseService, private appRef: ApplicationRef) {
  }

  ngOnInit() {
    const now = new Date();
    this.PushMessagesGridConfiguration.service = this.pushMessageDatabaseService;
  }
  ngAfterViewInit(): void {
    DxGridHelper.ConfigureGrid(this.Grid, this.PushMessagesGridRequest, this.PushMessagesGridConfiguration);
    // this.PushMessagesGridConfiguration.dataGrid.onRowClick.subscribe((e) => {
    //   this.show(e.data.id);
    // });
  }

  showAttendees(pushMessage) {
    this.selectedPushMessageId = pushMessage.id;
    this.showEditGuests = true;
  }
  show(pushMessageId) {
    this.selectedPushMessageId = pushMessageId;
    this.cloneExistingPushMessage = false;
    this.showPushMessage = true;
  }
  clonePushMessage(pushMessageId) {
    this.selectedPushMessageId = pushMessageId;
    this.cloneExistingPushMessage = true;
    this.showPushMessage = true;
  }
  newPushMessage() {
    this.selectedPushMessageId = null;
    this.cloneExistingPushMessage = false;
    this.showPushMessage = true;
  }
  closePopUp(refresh) {
    this.showPushMessage = false;
    if (refresh) {
      this.PushMessagesGridConfiguration.reloadGrid();
    }
  }

  search(value) {
    this.PushMessagesGridConfiguration.customSearch[0].value = value;
    this.PushMessagesGridConfiguration.dataGrid.instance.getDataSource().reload();
  }


}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/push-messages/push-messages-database/push-message-database.component.ts